var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClearSearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.89757 19.9999L4 19.1023L11.1024 11.9999L4 4.89745L4.89757 3.99988L12 11.1023L19.1024 3.99988L20 4.89745L12.8976 11.9999L20 19.1023L19.1024 19.9999L12 12.8974L4.89757 19.9999Z",
    fill: "#312B4D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClearSearchIcon);
export default __webpack_public_path__ + "static/media/clear-search-icon.5f006c26445d7219684186dbea4232cd.svg";
export { ForwardRef as ReactComponent };